type FieldErrorLineProps = {
  message?: string;
  'data-testid': string;
};

export const FieldErrorLine = ({
  message,
  'data-testid': testId
}: FieldErrorLineProps) => {
  if (!message) return null;

  return (
    <p data-testid={testId} className="mt-1 text-xs text-feedback-error">
      {message}
    </p>
  );
};
